import React from 'react'
import Link from 'gatsby-link'
import { Helmet } from "react-helmet";

import { Col, Button, Form, FormGroup, Label, Input, FormText, InputGroup, InputGroupAddon } from 'reactstrap';

import Block from '../components/block';
import Title from '../components/my-title';

import BlockCover from '../components/block-cover';
import ContactImage from '../assets/contact.jpg';

import data from '../data';

const Contact = () => (
  <div>
    <Helmet>
      <title>Pour votre projet de création en bois sur mesure, contactez nous</title>
      <meta name="description" content="Nous relevons tous les challenges pour nous adapter à vos exigences et vos contraintes pour la fabrication de votre projet sur mesure." />
    </Helmet>
    <BlockCover
      backgroundUrl={ContactImage}
      title="Contact et Projet"
      repeatedTitle={true} />

    <Block hasDecoration className="block-grey-background">
      <Title>J'ai un projet</Title>
      <p className="light fs-16 lh-23 text-align-center mb-4">
        Parlez-en avec nous :<br />
        nous sommes là pour le réaliser !
      </p>

      <Form method="post" data-netlify="true" data-netlify-honeypot="bot-field" name="projet" enctype="multipart/form-data">
        <input type="hidden" name="form-name" value="projet" />
        <p className="hidden">
          <label>Don’t fill this out: <input name="bot-field" /></label>
        </p>

        <div className="row justify-content-md-center">
          <div className="col-md-5">
            <FormGroup>
              <Input type="text" name="firstname" id="firstname" placeholder="Prénom" />
            </FormGroup>
            <FormGroup>
              <Input type="text" name="lastname" id="lastname" placeholder="Nom" />
            </FormGroup>
            <FormGroup>
              <Input type="email" name="email" id="email" placeholder="Adresse email" />
            </FormGroup>
            <FormGroup>
              <Input type="phone" name="phone" id="phone" placeholder="Téléphone" />
            </FormGroup>
            <FormGroup>
              <Input type="select" name="project" id="project">
                <option disabled selected>Projet</option>
                {data.default.map((item, index) => (
                  <option key={index} value={item.title}>{item.title}</option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <InputGroup>
                <Input placeholder="Zone géographique du chantier" type="text" />
                <InputGroupAddon>
                  <img src="/locate.svg" alt="Localisation" />
                </InputGroupAddon>
              </InputGroup>
            </FormGroup>
            <FormGroup row>
              <Label for="date" sm={6}>Date estimée du projet :</Label>
              <Col sm={6}>
                <Input type="date" name="date" id="date" placeholder="JJ/MM/AAAA" />
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label for="file" sm={12}>Envoi de plan, schéma, croquis ou photo en téléchargement :</Label>
              <Col sm={12}>
                <Input type="file" name="file" id="file" />
              </Col>
            </FormGroup>

            <div className="text-align-center">
              <button type="submit" className="btn btn-primary btn-big btn-min-width-300 mt-3">
                Envoyer
              </button>
            </div>

            <p className="color-grey fs-12 light mt-3 text-align-center">* Délai de réponse sous 72h</p>
          </div>
        </div>
      </Form>
    </Block>
  </div>
)

export default Contact



// WEBPACK FOOTER //
// ./src/pages/projet.js